module.exports = __webpack_public_path__ + "img/study-center-hover.bcbd572.png";